import React, { useState } from "react";
import { Button, Modal, Select } from "antd";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { useGlobalStore } from "@/store/hooks";
import ShopType from "@/enum/ShopType";

interface RenewalModalProps extends InjectBaseModalProps {
    shopType: string;
}

/**
 * 续费弹框，选择需要续费的店铺
 */
const RenewalModal: React.FC<RenewalModalProps> = observer(function (props) {
    const { shopType, open, onCancel } = props;

    const globalStore = useGlobalStore();
    const history = useHistory();

    const [selectShopId, updateSelectShopId] = useState<number>();

    function handleRenewClick() {
        if (!selectShopId) {
            Modal.error({
                title: "请选择一个店铺",
            });

            return;
        }

        history.push(`/setting/shop/appSubscription/index?shopId=${selectShopId}`);

        onCancel();
    }

    return (
        <Modal
            title="请选择需要续费的店铺"
            open={open}
            onCancel={onCancel}
            footer={
                <Button type="primary" onClick={handleRenewClick}>
                    去续费
                </Button>
            }
        >
            <span className="mr10">{ShopTypeNameMap[shopType]}</span>

            <Select<number>
                placeholder="请选择需要续费的店铺，可输入名称快速搜索"
                value={selectShopId}
                onChange={updateSelectShopId}
                className="w400"
                options={[
                    ...(globalStore.allowedShops
                        .filter((shop) => {
                            if (
                                shopType === ShopType.AIKUCUN &&
                                [ShopType.AIKUCUN, ShopType.AIKUCUN_V2].includes(shop.type)
                            ) {
                                return true;
                            } else {
                                return shop.type === shopType;
                            }
                        })
                        .map((shop) => {
                            return {
                                value: shop.id,
                                key: shop.id,
                                label: shop.name,
                            };
                        }) ?? []),
                ]}
            />
        </Modal>
    );
});

export default RenewalModal;
